import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import RecoverModal from '../../components/modals/recoverModal';
import PosForm from './posForm';
import VoidModal from '../../components/modals/voidModal';
import ViewModal from '../../components/modals/viewModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import CompoundProduct from '../../inventoryTab/product/forms/compound';
import SimpleProduct from '../../inventoryTab/product/forms/simple';
import SerializedProduct from '../../inventoryTab/product/forms/serialized';
import ProductionProduct from '../../inventoryTab/product/forms/production';
import DropDownFilter from '../../components/filters/dropDownFilter';
import AsyncDropDownFilter from '../../components/filters/asyncDropdownFilter';

import { FcViewDetails } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalInFormatter, totalOutFormatter } from '../../components/formatters/numberFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter } from '../../components/formatters/defFormatter';
import { createdHourFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Tabs, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';

import PosSales from './posSales';


function PosInvoice(props) {

  let { type, isDebit, isOrder } = props;

  const { api, userData, settingData, refProductData, devData, companyId, yearId, refData } = useContext(DataContext);
  const userRole = userData.role;

  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const [idRow, setIdRow] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [refreshTable, setRefreshTable] = useState(true);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
      refreshTableFunction();
    }
    setShowModal(!showModal);
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  useEffect(() => {
    refFetchData();
  }, []);

  const refFetchData = async () => {
    try {
      setIsLoading(true);
      const dataArray = ['category', 'salable', 'customerAccount', 'currency', 'delivery', 'posDetails']
      await refData(dataArray, companyId);
      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };


  const items = [
    {
      key: '1',
      label: 'Sales',
      children: <PosSales
        type={['PosSale', 'PosReturn']}
        showDelivery={false}
        refreshTable={refreshTable}
        setRefreshTable={setRefreshTable}
        refFetchData={refFetchData}
      />,
    },
    {
      key: '2',
      label: 'Orders',
      children: <PosSales
        type={['PosSaleOrder', 'PosReturnOrder']}
        showDelivery={true}
        refreshTable={refreshTable}
        setRefreshTable={setRefreshTable}
        refFetchData={refFetchData}
      />,
    }
  ];


  const tableFooter = (
    <div >

    </div>
  )

  return (


    <div style={{ alignItems: 'center' }}>

      {isLoading && <Loader />}

      {!isLoading && (

        <Tabs defaultActiveKey="1" centered={true} items={items} tabBarExtraContent={
          <Button
            style={{ backgroundColor: '#23576a', color: 'white' }}
            onClick={() => openModal(null)}
          >Add</Button>
        } destroyInactiveTabPane />

      )}

      {showModal &&
        <PosForm
          showModal={showModal}
          toggleModal={openModal}
          refFetchData={refFetchData}
        />
      }
    </div>
  )
}

export default PosInvoice;
